define('facets_faceted_navigation_item_empty_template.tpl', ['Handlebars','Handlebars.CompilerNameLookup'], function(Handlebars, _nl_){
	return _wrap_fn_('facets_faceted_navigation_item_empty_template', {"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "";
},"useData":true}, 'extensions/AwaLabs/FacetCellFields/1.0.2/', 'extensions/AwaLabs/FacetCellFields/1.0.2/', Handlebars);
});